import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get voucherType
export const getVoucherType = createAsyncThunk("voucherType/getVoucherType", async (params, { rejectWithValue }) => {
  try {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    const { data } = await API.getVoucherType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all voucherType
export const getAllVoucherType = createAsyncThunk("voucherType/getAllVoucherType", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllVoucherType();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("voucherType/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("voucherType/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "voucherType/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageVoucherType({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create voucherType
export const createVoucherType = createAsyncThunk(
  "voucherType/createVoucherType",
  async (data, { rejectWithValue }) => {
    const { name, voucherType } = data;
    try {
      const body = JSON.stringify({ name, voucherType });
      const { data } = await API.createVoucherType(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
export const updateVoucherType = createAsyncThunk(
  "voucherType/updateVoucherType",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const { name, voucherType } = values;
    try {
      const body = JSON.stringify({ name, voucherType });
      const { data } = await API.updateVoucherType(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("voucherType/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getVoucherType({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
